'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getBetaGroups();
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betagroups = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/betaGroups/${id}`).then(res => {
        this.getBetaGroups();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/betagroups/list/list.controller.js